import React from 'react'
import { func, number } from 'prop-types'
import Relazsizes from 'relazsizes'
import triggerEvent from 'utils/dataLayer'

import Button from 'components/atoms/Button'
import Markdown from 'components/atoms/MarkdownContent'
import Typography from 'components/atoms/Typography'
import Popup from 'components/molecules/Popup'

import config from 'config'

const { assets_url: assetsUrl } = config

const PopupSignup = ({ close, top }) => {
  const pathname = (typeof window === 'undefined') ? '' : window.location.pathname
  const signupData = {
    title: 'Yuk Daftar di Quipper Campus',
    description:
      'Selain karena daftar di Quipper Campus itu **GRATIS**, Kamu juga bisa mengenali diri kamu lebih dalam melalui **Tes Minat Bakat, Uji Potensi** hingga mendapatkan **Info Beasiswa** loh!',
    message: 'Buruan Daftar',
    link: `/signup?successUrl=${pathname}`,
    img: 'pop-up-signup@3x.png',
  }
  return (
    <Popup close={close} top={top}>
      <div className="popup-signup">
        <div className="popup-signup__content">
          <Relazsizes src={`${assetsUrl}/assets/img/popup-banner/${signupData.img}`} alt="Sign Up Pop-up Banner" />
          <Typography className="popup-signup__title" variant="title" component="span">
            {signupData.title}
          </Typography>
          <Typography variant="subbody" component="span" className="popup-signup__description">
            <Markdown content={signupData.description} />
          </Typography>
          {signupData.message &&
            <Typography variant="subbody" component="p">
              {signupData.message}
            </Typography>
          }
          <Button
            variant="default"
            className="popup-signup__button"
            component="a"
            href={signupData.link}
            onClick={() => triggerEvent('popup', { popup_action: 'register', page_location: pathname })}
          >
            Daftar Sekarang!
          </Button>
        </div>
        <style jsx global>
          {`
            .popup-signup {
              &__content {
                padding: 40px 24px;
                margin-top: 40px;
                text-align: center;
                img {
                  width: 100%;
                  display: block;
                  margin: 0 auto 24px;
                }
                p {
                  margin-top: 24px !important;
                  line-height: 1.5 !important;
                  color: #1a344f !important;
                }
              }
              &__button {
                display: block;
                width: 100%;
                padding: 12px 0;
                margin-top: 16px;
                font-weight: bold;
              }
              &__title {
                font-size: 24px !important;
              }
              @media screen and (min-width: 768px) {
                &__content {
                  max-width: 800px;
                  margin: auto;
                  padding-top: 100px;
                  img {
                    width: 400px;
                    margin: 0 auto 40px;
                  }
                  p {
                    font-size: 16px !important;
                  }
                }
                &__description p {
                  margin-top: 40px !important;
                  margin-bottom: 32px !important;
                }
                &__title {
                  font-size: 28px !important;
                }
                &__button {
                  width: max-content;
                  margin: 24px auto;
                  padding: 16px 32px;
                }
              }
            }
          `}
        </style>
      </div>
    </Popup>
  )
}

PopupSignup.propTypes = {
  close: func,
  top: number,
}

export default PopupSignup
